/*
  Sold-out roast notify-me.

  Posts to Klaviyo's NATIVE back-in-stock endpoint, so the send is handled by a Klaviyo flow
  built on the "Subscribed to Back in Stock" trigger and its Back in Stock delay component.
  Nobody has to remember to press anything when the lot lands.

  WHY A CUSTOM BUTTON AND NOT KLAVIYO'S OWN. Klaviyo's drop-in notify-me form assumes one product
  per page. This page sells three coffees from one buy box, so the form cannot tell which coffee
  the shopper means. The roast tile already carries its variant id, so we read it off the tile
  and send that. The same code covers any future sold-out roast with no new work.

  THIS DEPENDS ON SHOPIFY TELLING THE TRUTH. Klaviyo decides "back in stock" from the inventory
  it syncs from Shopify. If a variant is padded with a dummy quantity so the storefront never
  shuts it off, it never crosses out-of-stock -> in-stock and the flow never fires. The variant
  has to sit at 0 with "continue selling when out of stock" OFF. Verified against the live
  endpoint 2026-09-28: a 202 comes back, so the catalog is synced and the id below resolves.

  TWO OPTIONAL EXTRAS, both non-blocking:
  - the marketing opt-in checkbox adds them to a list, which is separate consent from the
    restock alert and is deliberately off by default;
  - a "Requested Back In Stock" event is logged for segmentation. Neither can fail the signup.
*/
(function () {
  if (window.__heistRoastWaitlist) return;
  window.__heistRoastWaitlist = true;

  var BIS_REVISION = "2026-07-15";
  var LIST_REVISION = "2024-10-15";
  /* Klaviyo namespaces catalog ids by integration. Shopify-synced variants are addressed as
     $shopify:::$default:::<shopify variant id>. */
  var VARIANT_PREFIX = "$shopify:::$default:::";
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function companyId(root) {
    var set = root.getAttribute("data-bpw-company");
    if (set) return set;
    /* Fall back to whatever the onsite script is loaded with, so this survives an account
       change even if nobody remembers the setting exists. */
    var s = document.querySelector('script[src*="klaviyo.com/onsite/js"][src*="company_id="]');
    var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    return m ? m[1] : "";
  }

  function seenKey(root) { return "heist_waitlist_" + (root.getAttribute("data-bpw-variant") || "x"); }

  function say(root, msg, isError) {
    var el = root.querySelector("[data-bpw-msg]");
    if (!el) return;
    el.textContent = msg || "";
    el.classList.toggle("bpw__msg--err", !!isError);
  }

  /* Analytics only. Wrapped and ignored - a tracking failure must never look like a failed
     signup to the shopper. */
  function track(root, email) {
    try {
      if (!window.klaviyo || !window.klaviyo.push) return;
      window.klaviyo.push(["identify", { $email: email }]);
      window.klaviyo.push(["track", "Requested Back In Stock", {
        ProductName: root.getAttribute("data-bpw-name") || "",
        VariantID: root.getAttribute("data-bpw-variant") || "",
        URL: window.location.href
      }]);
    } catch (e) {}
  }

  /* THE ONE THAT MATTERS. 202 is success and anything else is a real failure the shopper is
     told about, because there is no second path that would have caught them. */
  function subscribeBackInStock(company, variant, email) {
    var body = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: { data: { type: "profile", attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: "catalog-variant", id: VARIANT_PREFIX + variant } }
        }
      }
    };
    return fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=" + encodeURIComponent(company), {
      method: "POST",
      headers: { "Content-Type": "application/vnd.api+json", revision: BIS_REVISION },
      body: JSON.stringify(body)
    }).then(function (r) { return r.status === 202; });
  }

  /* Separate consent, separate call. A restock alert is not permission to send campaigns, so
     this only runs when the box is ticked, and it can fail without failing the signup. */
  function subscribeMarketing(root, company, email) {
    var list = root.getAttribute("data-bpw-list") || "";
    if (!list) return Promise.resolve(false);
    var body = {
      data: {
        type: "subscription",
        attributes: {
          profile: { data: { type: "profile", attributes: { email: email } } },
          custom_source: root.getAttribute("data-bpw-source") || "Roast waitlist"
        },
        relationships: { list: { data: { type: "list", id: list } } }
      }
    };
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(company), {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: LIST_REVISION },
      body: JSON.stringify(body)
    }).then(function (r) { return r.status === 202 || r.ok; }).catch(function () { return false; });
  }

  function wire(root) {
    var openBtn = root.querySelector("[data-bpw-open]");
    /* The PANEL is what opens, not the field row: the email box, the opt-in and the note are
       all held back until the button is pressed. */
    var panel = root.querySelector("[data-bpw-panel]") || root.querySelector("[data-bpw-form]");
    var input = root.querySelector("[data-bpw-email]");
    var submit = root.querySelector("[data-bpw-submit]");
    var optin = root.querySelector("[data-bpw-optin]");
    if (!openBtn || !panel || !input || !submit) return;

    try {
      if (window.localStorage && localStorage.getItem(seenKey(root))) {
        openBtn.hidden = true;
        say(root, root.getAttribute("data-bpw-already") || "You're on the list.");
      }
    } catch (e) {}

    openBtn.addEventListener("click", function () {
      openBtn.hidden = true;
      panel.hidden = false;
      input.focus();
    });

    function done(root) {
      panel.hidden = true;
      say(root, root.getAttribute("data-bpw-success") || "You're in. We'll find you.");
      try { if (window.localStorage) localStorage.setItem(seenKey(root), "1"); } catch (e) {}
    }

    function send() {
      var email = (input.value || "").trim();
      if (!EMAIL_RE.test(email)) {
        say(root, root.getAttribute("data-bpw-invalid") || "That email doesn't look right.", true);
        input.focus();
        return;
      }
      var company = companyId(root);
      var variant = root.getAttribute("data-bpw-variant") || "";
      if (!company || !variant) {
        say(root, root.getAttribute("data-bpw-error") || "Something went wrong. Try again in a minute.", true);
        return;
      }

      submit.disabled = true;
      input.disabled = true;
      say(root, root.getAttribute("data-bpw-sending") || "One second...");

      subscribeBackInStock(company, variant, email)
        .then(function (ok) {
          if (!ok) throw new Error("bis rejected");
          track(root, email);
          if (optin && optin.checked) subscribeMarketing(root, company, email);
          done(root);
        })
        .catch(function () {
          say(root, root.getAttribute("data-bpw-error") || "Something went wrong. Try again in a minute.", true);
        })
        .then(function () { submit.disabled = false; input.disabled = false; });
    }

    submit.addEventListener("click", function (e) { e.preventDefault(); send(); });
    input.addEventListener("keydown", function (e) {
      /* Enter inside the buy box would otherwise submit the product form and add to cart. */
      if (e.key === "Enter") { e.preventDefault(); e.stopPropagation(); send(); }
    });
  }

  ready(function () {
    var roots = document.querySelectorAll("[data-bpw]");
    for (var i = 0; i < roots.length; i++) wire(roots[i]);
  });
})();
